import { render, staticRenderFns } from "./OrderManageDetail.vue?vue&type=template&id=6eb8f61a&scoped=true"
import script from "./OrderManageDetail.vue?vue&type=script&lang=js"
export * from "./OrderManageDetail.vue?vue&type=script&lang=js"
import style0 from "./OrderManageDetail.vue?vue&type=style&index=0&id=6eb8f61a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb8f61a",
  null
  
)

export default component.exports